import clsx from "clsx";
import { SpinnerGap } from "@phosphor-icons/react";
import { GetIcon } from "../../../setup/utilities/icons";
import classes from "./Button.module.css";

type Props = {
  id?: any;
  title?: string | JSX.Element;
  style?: string;
  submit?: boolean;
  form?: string;
  iconPos?: "left" | "right";
  icon?: string;
  iconColor?: string;
  space?: string;
  onClick?: any;
  disabled?: boolean;
  iconSize?: number;
  alert?: boolean;
  /* Troca o ícone por um spinner e bloqueia o clique enquanto carrega */
  loading?: boolean;
};

const Button: React.FC<Props> = ({
  id,
  title,
  style,
  submit,
  form,
  iconPos,
  icon,
  iconColor,
  space,
  onClick,
  disabled,
  iconSize,
  alert,
  loading = false,
}) => {
  const JSXIcon = loading ? SpinnerGap : icon ? GetIcon(icon) || null : null;

  return (
    <button
      id={id ? id : null}
      className={clsx(
        style ? style : "btn btn-primary",
        (icon || loading) && "d-flex align-items-center",
        space && space,
      )}
      type={submit ? "submit" : "button"}
      onClick={() => {
        if (onClick) onClick();
      }}
      disabled={disabled || loading}
      form={form}
    >
      {alert ? (
        <>
          <span
            style={{
              translate: "19px -9px",
              position: "absolute",
              width: 7,
              height: 7,
              color: "var(--danger)",
              backgroundColor: "var(--danger)",
            }}
            className="d-flex align-items-center justify-content-center rounded-circle p-1 mr-2 pulse-dot"
          />
        </>
      ) : null}
      {iconPos === "right" ? title : null}
      {JSXIcon ? (
        <JSXIcon
          size={iconSize ? iconSize : 20}
          weight="bold"
          className={clsx(
            title && `${iconPos === "right" ? "ml-2" : "mr-2"}`,
            loading && classes.spinner,
          )}
          color={iconColor || undefined}
        />
      ) : null}
      {iconPos !== "right" ? title : null}
    </button>
  );
};

export default Button;
